// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_hwIaT {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.suggestionsContainer_U3cHI {
  position: absolute;
  background-color: white;
  border: 1px solid var(--lighter-grey);
  z-index: 1000;
  max-height: 50vh;
  overflow-y: scroll;
}
.suggestionsContainer_U3cHI > ul {
  list-style-type: none;
  padding-inline-start: 0;
  margin: 0;
}
.suggestionsContainer_U3cHI .suggestion_RqA0z {
  cursor: pointer;
  border-bottom: 1px solid var(--lighter-grey);
  padding: 8px;
  display: flex;
}
.suggestionsContainer_U3cHI .suggestion_RqA0z .highlighted_JKEhG {
  font-weight: bold;
}
.suggestionsContainer_U3cHI .suggestion_RqA0z:hover {
  background-color: var(--lighter-grey);
}
.advanced_q1k7d .row_hwIaT.noSpace_QtdLY {
  width: 100%;
}
.advanced_q1k7d .row_hwIaT.noSpace_QtdLY > * {
  margin: 0;
}
.advanced_q1k7d .row_hwIaT.noSpace_QtdLY .right_A4NI7 {
  margin-left: auto;
}
.advanced_q1k7d .editGroup_J41BY {
  margin: 0 auto 0 0;
}
.advanced_q1k7d .editGroup_J41BY > * {
  margin-right: 8px;
}
.openJson_hqXOO {
  width: 150px;
}
.historyItemArea_U2JeH {
  align-items: flex-start;
}
.endContainer_u157y {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.search_XAshI {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.header_MxVBs {
  display: flex;
}
.flexRight_yn42l {
  margin-left: auto;
}
.perPageDropdown_csTvi {
  min-width: 75px;
}
.left_YNamI {
  height: 100%;
}
.pagination_nv4Mo {
  border-top: 1px solid var(--lighter-grey);
  background: white;
  position: absolute;
  bottom: 0;
  margin: 0;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination_nv4Mo .innerPagination_AzNWH {
  margin: 0;
}
.header_MxVBs {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid var(--background);
}
.list_bHswJ {
  height: 100%;
  width: 100%;
  border: 1px solid var(--lighter-grey);
}
.content_A4yyO {
  height: 100%;
  padding: 10px 26px 10px 20px;
}
.right_A4NI7 {
  margin-left: auto;
  align-items: flex-start;
  justify-content: flex-end;
}
.right_A4NI7 .jump_MrNDJ {
  text-decoration: underline;
  cursor: pointer;
}
.right_A4NI7 .jump_MrNDJ:hover {
  color: var(--purple);
}
.icon_auEc5 {
  background-color: var(--purple);
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  margin-left: 0;
}
.icon_auEc5 .textTop_b1oux {
  vertical-align: text-top;
}
.splitRight_ZmRPp {
  width: 450px;
  height: 100%;
  background: var(--background);
}
.stopTimer_zzq0x i {
  color: var(--red);
}
.deleteTimer_S9xRu i {
  color: var(--grey);
}
.editor_emSPO {
  height: 100%;
}
.filter_jEixe {
  display: flex;
  flex: none;
  flex-direction: column;
  padding: 8px;
  width: 100%;
  margin: 0;
}
.noSpace_QtdLY {
  margin: 0;
}
.pathEditor_C8QiU .button_yukGf {
  margin-left: auto;
  margin-bottom: 8px;
  color: var(--purple);
  opacity: 0.5;
}
.pathEditor_C8QiU .button_yukGf:hover {
  opacity: 1;
  color: var(--purple);
}
.pathEditor_C8QiU input {
  padding-left: 10px;
  padding-right: 10px;
  padding: 5px;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border: 1px solid #e5e5e5;
  border-radius: 0;
  font-weight: 300;
  font-size: 16px;
}
.pathEditor_C8QiU input:focus {
  border-color: #5737BE;
  outline-width: 0;
}
.pathEditor_C8QiU:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.modal_lbEd7 {
  overflow-y: scroll;
}
.modal_lbEd7 .modalHeader_PIMBP {
  display: flex;
  flex-direction: column;
}
.modal_lbEd7 .modalHeader_PIMBP .close_kj1QF {
  margin-left: auto;
  font-size: 20px;
}
.modal_lbEd7 .modalHeader_PIMBP .title_p0rOI {
  font-size: 18px;
  /*font-family: Montserrat, san-serif;*/
  color: #5737BE;
  font-weight: 500;
  margin-left: 8px;
}
.modal_lbEd7 .modalBody_YQ1oR {
  overflow-y: scroll;
}
.modal_lbEd7 .modalBody_YQ1oR .castDrop_KHb7Z {
  min-width: 150px;
}
.modal_lbEd7 .modalBody_YQ1oR .rootOperator_xYNk7 {
  font-weight: bold;
}
.whereEditor_ogWET .button_yukGf {
  margin-left: auto;
  color: var(--purple);
  opacity: 0.5;
}
.whereEditor_ogWET .button_yukGf:hover {
  opacity: 1;
  color: var(--purple);
}
.whereEditor_ogWET .deleteWhere_imrS9 {
  margin-left: auto;
}
.whereEditor_ogWET input {
  padding-left: 10px;
  padding-right: 10px;
  padding: 5px;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border: 1px solid #e5e5e5;
  border-radius: 0;
  font-weight: 300;
  font-size: 16px;
}
.whereEditor_ogWET input:focus {
  border-color: #5737BE;
  outline-width: 0;
}
.whereEditor_ogWET:hover {
  background: rgba(0, 0, 0, 0.1);
}
.logicEditor_B6fXq {
  background: rgba(0, 0, 0, 0.05);
}
.logicEditor_B6fXq .logicHeader_fb9kq {
  padding: 8px 8px 0 8px;
  display: flex;
}
.logicEditor_B6fXq .logicHeader_fb9kq .button_yukGf {
  margin-left: auto;
  color: var(--purple);
  opacity: 0.5;
}
.logicEditor_B6fXq .logicHeader_fb9kq .button_yukGf:hover {
  color: var(--purple);
  opacity: 1;
}
.logicEditor_B6fXq .clauses_bB5uG {
  padding-left: 24px;
}
.row_hwIaT {
  flex-direction: row;
}
.center_DCDY7 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.center_DCDY7 .loadMore_NpvAE {
  color: var(--purple);
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/editors/query/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,4CAA4C;EAC5C,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":["@import \"../../style/theme.css\";\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n.suggestionsContainer {\n  position: absolute;\n  background-color: white;\n  border: 1px solid var(--lighter-grey);\n  z-index: 1000;\n  max-height: 50vh;\n  overflow-y: scroll;\n}\n.suggestionsContainer > ul {\n  list-style-type: none;\n  padding-inline-start: 0;\n  margin: 0;\n}\n.suggestionsContainer .suggestion {\n  cursor: pointer;\n  border-bottom: 1px solid var(--lighter-grey);\n  padding: 8px;\n  display: flex;\n}\n.suggestionsContainer .suggestion .highlighted {\n  font-weight: bold;\n}\n.suggestionsContainer .suggestion:hover {\n  background-color: var(--lighter-grey);\n}\n.advanced .row.noSpace {\n  width: 100%;\n}\n.advanced .row.noSpace > * {\n  margin: 0;\n}\n.advanced .row.noSpace .right {\n  margin-left: auto;\n}\n.advanced .editGroup {\n  margin: 0 auto 0 0;\n}\n.advanced .editGroup > * {\n  margin-right: 8px;\n}\n.openJson {\n  width: 150px;\n}\n.historyItemArea {\n  align-items: flex-start;\n}\n.endContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.search {\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.perPageDropdown {\n  min-width: 75px;\n}\n.left {\n  height: 100%;\n}\n.pagination {\n  border-top: 1px solid var(--lighter-grey);\n  background: white;\n  position: absolute;\n  bottom: 0;\n  margin: 0;\n  height: 40px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.pagination .innerPagination {\n  margin: 0;\n}\n.header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid var(--background);\n}\n.list {\n  height: 100%;\n  width: 100%;\n  border: 1px solid var(--lighter-grey);\n}\n.content {\n  height: 100%;\n  padding: 10px 26px 10px 20px;\n}\n.right {\n  margin-left: auto;\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n.right .jump {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.right .jump:hover {\n  color: var(--purple);\n}\n.icon {\n  background-color: var(--purple);\n  color: white;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 5px;\n  margin-left: 0;\n}\n.icon .textTop {\n  vertical-align: text-top;\n}\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background: var(--background);\n}\n.stopTimer i {\n  color: var(--red);\n}\n.deleteTimer i {\n  color: var(--grey);\n}\n.editor {\n  height: 100%;\n}\n.filter {\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  padding: 8px;\n  width: 100%;\n  margin: 0;\n}\n.noSpace {\n  margin: 0;\n}\n.pathEditor .button {\n  margin-left: auto;\n  margin-bottom: 8px;\n  color: var(--purple);\n  opacity: 0.5;\n}\n.pathEditor .button:hover {\n  opacity: 1;\n  color: var(--purple);\n}\n.pathEditor input {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding: 5px;\n  border-top-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border: 1px solid #e5e5e5;\n  border-radius: 0;\n  font-weight: 300;\n  font-size: 16px;\n}\n.pathEditor input:focus {\n  border-color: #5737BE;\n  outline-width: 0;\n}\n.pathEditor:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.modal {\n  overflow-y: scroll;\n}\n.modal .modalHeader {\n  display: flex;\n  flex-direction: column;\n}\n.modal .modalHeader .close {\n  margin-left: auto;\n  font-size: 20px;\n}\n.modal .modalHeader .title {\n  font-size: 18px;\n  /*font-family: Montserrat, san-serif;*/\n  color: #5737BE;\n  font-weight: 500;\n  margin-left: 8px;\n}\n.modal .modalBody {\n  overflow-y: scroll;\n}\n.modal .modalBody .castDrop {\n  min-width: 150px;\n}\n.modal .modalBody .rootOperator {\n  font-weight: bold;\n}\n.whereEditor .button {\n  margin-left: auto;\n  color: var(--purple);\n  opacity: 0.5;\n}\n.whereEditor .button:hover {\n  opacity: 1;\n  color: var(--purple);\n}\n.whereEditor .deleteWhere {\n  margin-left: auto;\n}\n.whereEditor input {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding: 5px;\n  border-top-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border: 1px solid #e5e5e5;\n  border-radius: 0;\n  font-weight: 300;\n  font-size: 16px;\n}\n.whereEditor input:focus {\n  border-color: #5737BE;\n  outline-width: 0;\n}\n.whereEditor:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.logicEditor {\n  background: rgba(0, 0, 0, 0.05);\n}\n.logicEditor .logicHeader {\n  padding: 8px 8px 0 8px;\n  display: flex;\n}\n.logicEditor .logicHeader .button {\n  margin-left: auto;\n  color: var(--purple);\n  opacity: 0.5;\n}\n.logicEditor .logicHeader .button:hover {\n  color: var(--purple);\n  opacity: 1;\n}\n.logicEditor .clauses {\n  padding-left: 24px;\n}\n.row {\n  flex-direction: row;\n}\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.center .loadMore {\n  color: var(--purple);\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_hwIaT`,
	"suggestionsContainer": `suggestionsContainer_U3cHI`,
	"suggestion": `suggestion_RqA0z`,
	"highlighted": `highlighted_JKEhG`,
	"advanced": `advanced_q1k7d`,
	"noSpace": `noSpace_QtdLY`,
	"right": `right_A4NI7`,
	"editGroup": `editGroup_J41BY`,
	"openJson": `openJson_hqXOO`,
	"historyItemArea": `historyItemArea_U2JeH`,
	"endContainer": `endContainer_u157y`,
	"search": `search_XAshI`,
	"header": `header_MxVBs`,
	"flexRight": `flexRight_yn42l`,
	"perPageDropdown": `perPageDropdown_csTvi`,
	"left": `left_YNamI`,
	"pagination": `pagination_nv4Mo`,
	"innerPagination": `innerPagination_AzNWH`,
	"list": `list_bHswJ`,
	"content": `content_A4yyO`,
	"jump": `jump_MrNDJ`,
	"icon": `icon_auEc5`,
	"textTop": `textTop_b1oux`,
	"splitRight": `splitRight_ZmRPp`,
	"stopTimer": `stopTimer_zzq0x`,
	"deleteTimer": `deleteTimer_S9xRu`,
	"editor": `editor_emSPO`,
	"filter": `filter_jEixe`,
	"pathEditor": `pathEditor_C8QiU`,
	"button": `button_yukGf`,
	"modal": `modal_lbEd7`,
	"modalHeader": `modalHeader_PIMBP`,
	"close": `close_kj1QF`,
	"title": `title_p0rOI`,
	"modalBody": `modalBody_YQ1oR`,
	"castDrop": `castDrop_KHb7Z`,
	"rootOperator": `rootOperator_xYNk7`,
	"whereEditor": `whereEditor_ogWET`,
	"deleteWhere": `deleteWhere_imrS9`,
	"logicEditor": `logicEditor_B6fXq`,
	"logicHeader": `logicHeader_fb9kq`,
	"clauses": `clauses_bB5uG`,
	"center": `center_DCDY7`,
	"loadMore": `loadMore_NpvAE`
};
export default ___CSS_LOADER_EXPORT___;
